import template from './page.signature-block.html';
import signatureItem from './signature-item/signature-block.signature-item';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.signature-block',
    [signatureItem]
  )
  .component('tcSignatureBlock', {
    //tc-signature-block
    template,
    bindings: {
      me: '<',
      data: '<',
      element: '<',
      fields: '<',
    },
    controller: function () {},
  }).name;
